// extracted by mini-css-extract-plugin
module.exports = {"assign-owner-title":"AssignOwnerStepper_assign-owner-title__21JIM"};